import { mediaMax } from '@/app/styles/breakpoints'
import { Flex, Modal, Tabs } from 'antd'
import styled from 'styled-components'

export const FilterTabs = styled(Tabs)`
  && {
    .ant-tabs-tab {
      border-bottom: none;
      &.ant-tabs-tab-active {
        border-color: ${(props) => props.theme.colors.divider};
        .ant-tabs-tab-btn {
          text-shadow: none;
        }
      }
      &:not(.ant-tabs-tab-active) {
        .ant-tabs-tab-btn:active,
        .ant-tabs-tab-btn:focus {
          color: inherit;
        }
      }
    }
  }
`

export const Content = styled(Flex)`
  flex: 1;
  && {
    .ant-table-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      .ant-spin-nested-loading {
        flex: 1;
        display: flex;
        flex-direction: column;
        .ant-spin-container {
          flex: 1;
          display: flex;
          flex-direction: column;
          .ant-table {
            white-space: nowrap;
            flex: 1;
            display: flex;
            flex-direction: column;
            .ant-table-container {
              flex: 1;
              display: flex;
              flex-direction: column;
              .ant-table-body {
                flex: 1 1 0;
                overflow-y: auto !important;
              }
            }
          }
        }
      }
    }
  }
  && {
    .ant-table-wrapper
      .ant-table.ant-table-bordered
      > .ant-table-container
      > .ant-table-body
      > table
      > tbody
      > tr
      > td.cell-button {
      padding: 0;
    }
    .ant-table-thead {
      .ant-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .ant-table-body {
      scrollbar-width: thin;
      scrollbar-color: ${(props) => props.theme.colors.divider} transparent;

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.colors.divider};
        border-radius: 2px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: ${(props) => props.theme.colors.text};
      }

      &::-webkit-scrollbar-button {
        display: none;
      }
    }
  }
`

export const TaskModal = styled(Modal)`
  && {
    ${mediaMax.sm} {
      position: fixed;
      min-width: 100vw;
      min-height: 100vh;
      height: 100vh;
      top: 0;
      left: 0;
      margin: 0;
      display: flex !important;
      flex-direction: column;
      & > div {
        display: flex;
        flex-direction: column;
        height: 100vh;
      }
    }
    .ant-modal-content {
      padding: 0;
      ${mediaMax.sm} {
        max-height: inherit;
        flex: 1;
        padding: 24px 0 16px;
        overflow: auto;
      }
    }
    .ant-modal-close {
      top: 36px;
      inset-inline-end: 24px;
    }
  }
`
